@if (icon) {
  <mat-icon class="material-symbols-rounded mx-0 w-full text-center">
    {{ icon }}
  </mat-icon>
} @else {
  <stream-icon [icon]="name" />
}
